export default {
	hrv_preload_error: "获取图片集失败，请检查网络后重试",
	hrv_title_key: "鹰瞳人工智能抗压能力检测中",
	hrv_generate_title_key: "鹰瞳抗压能力评估报告生成中...",
	hrv_test_tip1_key: "请保持坐姿",
	hrv_test_tip2_key: "深呼吸",
	hrv_test_tip3_key: "即将开始检测",
	hrv_test_hook_device_load_key: "设备自检",
	hrv_test_hook_modal_load_key: "眼动模型加载",
	hrv_test_hook_testset_load_key: "测试集加载",
	hrv_test_hook_environment_load_key: "网络检测",
	hrv_test_hook_distance_load_key: "距离检测",
	hrv_test_hook_finger_load_key: "采集器检测",
	hrv_test_hook_without_token_key: "用户信息生效，请重新登录",
	hrv_test_hook_network_good_key: "网速良好，正在进行距离检测。",
	hrv_test_hook_network_bad_key: "网速过低，请检查您的网络连接。",
	hrv_test_imagebox_tip_key: "请注视影像",
	hrv_finished_backbtn_key: "返回",
	hrv_finished_title_key: "抗压能力检测",
	hrv_finished_network_error_key: "数据上传失败，请检查网络后重新上传",
	hrv_finished_submit_error_key: "本次采集数据不达标，请重新进行检测",
	hrv_finished_unknown_error_key: "未知错误，请联系客服",
	hrv_finished_reupload_key: "重新上传",
	hrv_finished_redetect_key: "重新检测",
	hrv_finished_quit_test_key: "您确定放弃本次检测吗？",
	hrv_title_wait_key: "检测即将开始",
	hrv_test_hook_finger_disconnected_key: "请配置指夹式数据采集器",
	face_not_detected_mix_key:
		"请将您的脸部对准设备，确保光线充足。保持脸部正对设备，勿遮挡面部，确认面部显示在方框中间。",
	face_not_detected_key: "请将您的脸部对准设备，确保光线充足。",
	face_not_detected_key2:
		"保持脸部正对设备，勿遮挡面部，确认面部显示在方框中间。",
	face_too_small_key: "请靠近屏幕。",
	face_too_close_to_edge_key: "请调整位置，确认面部显示在方框中间。",
	face_multiple_detected_key: "请检测者保持在镜头范围内，其他人员离开。",
	face_too_large_key: "请距离屏幕远一些，确认面部显示在方框中间。",
	hrv_stage1_key:
		"请保持正确坐姿。请观察屏幕上显示的影像，其中包含精神和心理方面的关键信号与重要信息，评估过程将持续90秒。",
	hrv_stage2_key: "请认真观察图片。",
	hrv_stage2_timeleft_key: "总倒计时：",
	seconds_key: "秒",
	hrv_stage2_leftimage_key: "请注视左侧影像",
	hrv_stage2_fps_key: "视频帧率:",
	hrv_idnum: "编号:",
	hrv_username: "姓名:",
	hrv_gender: "性别:",
	hrv_select_gender: "请选择性别",
	male_key: "男",
	female_key: "女",
	hrv_age_key: "年龄:",
	hrv_select_age_key: "请选择年龄",
	start_key: "开始",
	model_initing_key: "深呼吸冷静下来，请稍候...",
	report_generating_key: "正在生成报告，请稍候...",
	report_generate_exception_key:
		"报告生成异常，如已经按照提示正确操作，请联系设备管理员检查设备。",
	report_generate_complete_report_later_key: "报告已生成，请稍后查看",
	exit_key: "退出",
	username_key: "姓名",
	gender_key: "性别",
	age_key: "年龄",
	idnum_key: "编号",
	check_time_key: "检查时间",
	adjust_by_tips_key: "请根据提示进行调整",
	tips_key: "提示",
	confirm_key: "确认",
	hrv_report_title_key: "鹰瞳抗压能力检测报告",
	report_doctor_key: "报告医师",
	colon_key: "：",
	signature_key: "签名",
	report_date_key: "报告日期",
	date_key: "日期",
	report_hospital_seal: "医院盖章",
	seal_key: "盖章",
	print_report_key: "打印报告",
	return_key: "返回",
	hrv_finish_tip_scan: "检测完成，请在手机端查看报告。",
	hrv_finish_tip_input: "检测完成。",
	hrv_finish_btn: "确定",
	hrv_back_btn: "取消",
	hrv_init_tips:
		"请将脸部正对设备，确保面部位于影像中央，保持面部光线充足，勿遮挡面部。",
	hrv_init_ready: "开始",
	frequency_domain_analysis_key: "频域分析图",
	autonomic_nervous_analysis_key: "自主神经系统评估",
	stress_evaluation_key: "抗压能力评估",
	rr_interval_histogram_key: "RR间期分布直方图",
	index_interpretation_report_key: "指标解读报告",
	balance_autonomic_nervous_key: "自主神经平衡性",
	activity_autonomic_nervous_key: "自主神经活性",
	physical_pressure_key: "身体压力",
	mental_pressure_key: "心理压力",
	stress_resistance_key: "抗压能力",
	hrv_param_key: "心率变异性分析参数",
	time_domain_param_key: "时域分析参数",
	frequency_domain_param_key: "频域分析参数",
	metric_key: "指标",
	figure_key: "数值",
	balance_detail_key:
		'# 自主神经平衡性：为你的身心找到最佳"速度与激情"\n\n\n## 原理\n自主神经平衡性可以被看作是你生活中的"加速与刹车"系统。交感神经就像是加速器，帮助你在紧急情况中迅速应对，而副交感神经则像刹车，帮助你在压力过去后回归平静。当这两者保持平衡，你就能以最佳状态应对生活中的挑战和机遇。\n\n\n## 建议\n\n\n### 平衡性正常（50-70）\n* 保持适度的运动，如慢跑、游泳或瑜伽，每周3次以上。这些运动有助于你继续稳定情绪，让生活中的加速和刹车更加平滑，充满乐趣。\n* 尽管目前状态正常，但生活中的各种突发状况可能会迅速打破这种平衡。\n* 为了更好地保持您的身心健康，建议您结合 **TSC-102 心理健康多模态检查仪** 定期监测自主神经活性，及时调整运动计划。同时，使用 **TSL-102W 阳光宝** 进行光疗也可以进一步提升情绪稳定性，帮您打造更健康的生活方式。了解更多产品信息请添加SoulHeal企业微信号咨询产品价格助力心理健康。',
	activity_detail_key:
		"# 自主神经活性：让生活的音符奏出最佳旋律\n\n\n## 原理\n想象你的自主神经活性像一台音响的音量控制。音量太高可能会刺耳，让你难以承受；音量太低则无法听清，影响体验。只有调到适中的音量，你才能听到最美妙的旋律，体验到最佳的生活状态。\n\n\n## 建议\n\n\n### 活性正常（50-70）\n* 继续保持你的健康生活方式，这样你就能持续奏响生活中美妙的旋律，享受每一个愉悦的瞬间。\n* 正常的活性并不意味着可以掉以轻心，保持警觉和适度调整非常重要。\n* 定期使用 **TSC-102 心理健康多模态检查仪**，更好地掌握自主神经活性的变化，帮助您及时进行调整。了解更多产品信息请添加SoulHeal企业微信号咨询产品价格助力心理健康。",
	physical_pressure_detail_key:
		'# 身体压力：让"气球"保持适当的压力\n\n\n## 原理\n身体压力可以看作是气球中的空气。适量的压力会让气球维持良好的形状，但如果充气过多，气球随时都有爆炸的风险。你的身体也是如此，适度的压力可以激发潜能，但过高的压力会造成伤害。\n\n\n## 建议\n\n\n### 压力正常（40-60）\n* 保持目前的生活习惯和适度的运动，让你的身体压力保持在"安全区"，充满能量却不过度紧张。\n* 正常的压力水平可能因外界环境迅速变化，需做好应对各种变化的准备。\n* 结合 **TSC-102 心理健康多模态检查仪** 进行定期监测，确保身体压力的稳定性。了解更多产品信息请添加SoulHeal企业微信号咨询产品价格助力心理健康。',
	mental_pressure_detail_key:
		'# 心理压力：保持"心灵的水位"在理想高度\n\n\n## 原理\n心理压力可以比作心灵中的水位。适度的水位可以滋养你的心灵，但当水位过高时，可能会溢出，影响情绪和生活。你的目标是让这片"心灵的湖泊"既充满活力，又不会泛滥成灾。\n\n\n## 建议\n\n\n### 压力正常（30-50）\n* 继续培养兴趣爱好，参加社交活动，保持你的心灵湖泊在健康的水位，让它永远充满生命力。\n* 即使现在处于正常范围，但各种生活挑战可能会轻易打破这种平衡。\n* 结合 **TSC-102 心理健康多模态检查仪** 定期进行心理监测，以便及时掌握心理状态的变化。了解更多产品信息请添加SoulHeal企业微信号咨询产品价格助力心理健康。',
	stress_resistance_detail_key:
		'# 抗压能力：打造坚固的"心理桥梁"\n\n\n## 原理\n抗压能力可以比作桥梁的承重能力。桥梁越坚固，就越能承受更多的重量，而不至于崩塌。你就是自己生活的建筑师，构建一座能够承载所有挑战的坚固桥梁。\n\n\n## 建议\n\n\n### 抗压能力正常（50-70）\n* 通过社交活动增强你的社会支持系统，学习新的兴趣技能，让这座桥梁更加稳固，准备迎接未来的每一次挑战。\n* 抗压能力虽处于正常水平，但仍需提升以更好应对未来可能的挑战。\n* 使用 **TSC-102 心理健康多模态检查仪**，监测抗压能力，了解自己的心理健康水平。了解更多产品信息请添加SoulHeal企业微信号咨询产品价格助力心理健康。',
	emotion_title_key: "表情分析",
	emotion_sys_desc_key: "表情分析系统介绍",
	emotion_sys_welcome_key:
		"欢迎使用我们的表情分析系统。这个强大的工具利用最新的深度学习技术，为您提供精确的情绪识别。",
	emotion_sys_welcome_key1: '请将脸部正对设备，点击下方的"开始"按钮',
	emotion_sys_desc1_key:
		"表情分析基于先进的深度学习模型，能够准确识别多种情绪状态。",
	emotion_sys_desc2_key:
		"系统默认每5秒采集一帧图像进行分析，采集3帧后自动生成综合报告。",
	emotion_sys_desc3_key: "在心理健康领域，表情分析有着广泛的应用：",
	emotion_sys_desc3_li1_key: "协助心理咨询师更好地理解患者的情绪变化。",
	emotion_sys_desc3_li2_key: "为自闭症患者的情绪识别训练提供客观数据支持。",
	emotion_sys_desc3_li3_key: "帮助评估抑郁症患者的情绪状态，辅助治疗进程。",
	emotion_sys_desc3_li4_key:
		"在远程心理健康服务中，提供实时情绪反馈，增强治疗效果。",
	emotion_sys_pre_start_key:
		'准备好开始探索您的情绪世界了吗？点击下方的"开始"按钮，开启您的表情分析之旅！',
	finish_key: "结束",
	emotion_report_title_key: "心理健康情绪状态评估报告",
	evaluation_date_key: "评估日期",
	evaluation_method_key: "评估方式",
	report_number_key: "报告编号",
	emotion_sys_ai_key: "AI情绪识别系统",
	emotion_report_section1_key: "一、评估概述",
	dear_key: "亲爱的",
	emotion_report_section1_desc_key:
		"这份报告使用了先进的情绪识别技术，帮助我们更好地了解您的情绪状态。这项技术就像是一个细心的观察者，可以捕捉到您的情绪变化，帮助我们一起找到改善心理健康的方法。",
	emotion_report_section2_key: "二、情绪状态分析",
	emotion_report_section2_h3_key: "1. 情绪活跃度（Arousal）",
	emotion_report_section2_h3_desc1_key: "您的情绪活跃度显示为",
	emotion_report_section2_h3_desc2_key:
		"水平，这表示您的情绪能量水平。就像汽车的引擎转速：",
	emotion_report_section2_h3_li1_key: "高活跃：像引擎高速运转",
	emotion_report_section2_h3_li2_key: "低活跃：像引擎怠速状态",
	emotion_report_section2_h3_2_key: "2. 情绪效价（Valence）",
	emotion_report_section2_h3_2_desc1_key: "您的情绪效价呈现",
	emotion_report_section2_h3_2_desc2_key:
		"特征，这反映了您的情绪色彩。可以理解为：",
	emotion_report_section2_h3_2_li1_key: "正向：如阳光明媚的天气",
	emotion_report_section2_h3_2_li2_key: "负向：如阴雨连绵的日子",
	emotion_report_section2_h3_3_key: "3. 主要情绪分布",
	emotion_report_section2_h3_3_xy1_key: "第一象限（高活跃-正向）",
	emotion_report_section2_h3_3_xy1_desc1_key: "情绪表现：兴奋、喜悦",
	emotion_report_section2_h3_3_xy1_desc2_key: "典型场景：",
	emotion_report_section2_h3_3_xy1_desc2_li1_key: "社交活动中感到愉悦和兴奋",
	emotion_report_section2_h3_3_xy1_desc2_li2_key: "完成工作目标时的成就感",
	emotion_report_section2_h3_3_xy1_desc2_li3_key:
		"运动或体育活动后的活力充沛",
	emotion_report_section2_h3_3_xy1_desc2_li4_key: "收到好消息时的喜悦",
	emotion_report_section2_h3_3_xy1_desc2_li5_key: "与家人朋友团聚时的快乐",
	emotion_report_section2_h3_3_xy2_key: "第二象限（高活跃-负向）",
	emotion_report_section2_h3_3_xy2_desc1_key: "情绪表现：紧张、焦虑",
	emotion_report_section2_h3_3_xy2_desc2_li1_key: "工作/学习压力大时的焦虑",
	emotion_report_section2_h3_3_xy2_desc2_li2_key: "人际冲突后的愤怒",
	emotion_report_section2_h3_3_xy2_desc2_li3_key: "重要事件前的紧张",
	emotion_report_section2_h3_3_xy2_desc2_li4_key: "突发事件引起的慌张",
	emotion_report_section2_h3_3_xy2_desc2_li5_key: "等待重要结果时的不安",
	emotion_report_section2_h3_3_xy3_key: "第三象限（低活跃-负向）",
	emotion_report_section2_h3_3_xy3_desc1_key: "情绪表现：疲倦、低落",
	emotion_report_section2_h3_3_xy3_desc2_li1_key: "工作日结束后的疲惫",
	emotion_report_section2_h3_3_xy3_desc2_li2_key: "失眠后的精神不振",
	emotion_report_section2_h3_3_xy3_desc2_li3_key: "计划受阻时的沮丧",
	emotion_report_section2_h3_3_xy3_desc2_li4_key: "独处时的孤独感",
	emotion_report_section2_h3_3_xy3_desc2_li5_key: "阴雨天气影响的低落",
	emotion_report_section2_h3_3_xy4_key: "第四象限（低活跃-正向）",
	emotion_report_section2_h3_3_xy4_desc1_key: "情绪表现：平静、放松",
	emotion_report_section2_h3_3_xy4_desc2_li1_key: "清晨醒来后的平静",
	emotion_report_section2_h3_3_xy4_desc2_li2_key: "深呼吸放松时的安宁",
	emotion_report_section2_h3_3_xy4_desc2_li3_key: "泡温暖浴时的舒适",
	emotion_report_section2_h3_3_xy4_desc2_li4_key: "做冥想时的宁静",
	emotion_report_section2_h3_3_xy4_desc2_li5_key: "欣赏自然时的祥和",
	emotion_report_section3_key: "三、个性化建议",
	emotion_report_section3_key_desc1:
		"（基于美国心理学会APA指南和美国国立卫生研究院NIH建议）",
	emotion_report_section3_key_desc2_1: "1. 日常调节建议",
	emotion_report_section3_key_desc2_1_a: "a) 睡眠管理",
	emotion_report_section3_key_desc2_1_a_li1:
		"保持固定就寝时间，建议22:00-23:00之间",
	emotion_report_section3_key_desc2_1_a_li2: "睡前1小时避免使用电子设备",
	emotion_report_section3_key_desc2_1_a_li3: "保持卧室温度在18-22℃",
	emotion_report_section3_key_desc2_1_a_li4: '使用"5-4-3-2-1"感官放松法入睡',
	emotion_report_section3_key_desc2_1_b: "b) 运动建议",
	emotion_report_section3_key_desc2_1_b_li1:
		"每周进行150分钟中等强度有氧运动",
	emotion_report_section3_key_desc2_1_b_li2: "推荐：步行、游泳、瑜伽",
	emotion_report_section3_key_desc2_1_b_li3: "每次运动20-30分钟",
	emotion_report_section3_key_desc2_1_b_li4:
		"运动时间最好在早上或下午，避免晚上剧烈运动",
	emotion_report_section3_key_desc2_1_c: "c) 饮食调节",
	emotion_report_section3_key_desc2_1_c_li1:
		"增加Omega-3脂肪酸摄入（鱼类、坚果）",
	emotion_report_section3_key_desc2_1_c_li2: "保证每天摄入足够水分（1.5-2L）",
	emotion_report_section3_key_desc2_1_c_li3:
		"限制咖啡因摄入，最好在下午2点前饮用",
	emotion_report_section3_key_desc2_1_c_li4:
		"添加富含色氨酸的食物（香蕉、火鸡肉）",
	emotion_report_section3_key_desc2_1_d: "d) 社交活动",
	emotion_report_section3_key_desc2_1_d_li1: "每周安排2-3次面对面社交",
	emotion_report_section3_key_desc2_1_d_li2: "参加兴趣小组或志愿活动",
	emotion_report_section3_key_desc2_1_d_li3:
		"保持每日与家人15分钟的高质量交谈",
	emotion_report_section3_key_desc2_1_d_li4: "建立支持性社交圈",
	emotion_report_section3_key_desc2_2: "2. 专业支持建议",
	emotion_report_section3_key_desc2: "（基于美国精神病学会APA指南）",
	emotion_report_section3_key_desc2_2_a: "a) 心理咨询",
	emotion_report_section3_key_desc2_2_a_li1: "建议每周进",
	emotion_report_section3_key_desc2_2_a_li2:
		"建议每周进行一次45-50分钟的个人咨询",
	emotion_report_section3_key_desc2_2_a_li3:
		"选择认知行为疗法（CBT）或正念认知疗法（MBCT）",
	emotion_report_section3_key_desc2_2_a_li4: "参与团体治疗，每两周一次",
	emotion_report_section3_key_desc2_2_a_li5: "保持治疗日志记录",
	emotion_report_section3_key_desc2_2_b: "b) 放松技巧",
	emotion_report_section3_key_desc2_2_b_li1:
		"进行渐进性肌肉放松训练（每天15分钟）",
	emotion_report_section3_key_desc2_2_b_li2:
		"练习4-7-8呼吸法（每天3次，每次4轮）",
	emotion_report_section3_key_desc2_2_b_li3: "正念冥想（早晚各10分钟）",
	emotion_report_section3_key_desc2_2_b_li4:
		"使用指导性想象（推荐使用专业APP辅助）",
	emotion_report_section3_key_desc2_2_c: "c) 就医指导",
	emotion_report_section3_key_desc2_2_c_li1: "每月进行一次情绪评估随访",
	emotion_report_section3_key_desc2_2_c_li2: "必要时考虑药物治疗评估",
	emotion_report_section3_key_desc2_2_c_li3: "定期进行身体检查排除躯体疾病",
	emotion_report_section3_key_desc2_2_c_li4: "建立危机干预预案",
	emotion_report_section4_key: "四、进步与改善空间",
	emotion_report_section4_key_1: "1. 积极变化",
	emotion_report_section4_key_1_li1:
		"情绪识别能力提升（能够准确命名当前情绪）",
	emotion_report_section4_key_1_li2:
		"自我调节技能增强（能运用呼吸法缓解焦虑）",
	emotion_report_section4_key_1_li3: "人际关系改善（主动寻求社交支持）",
	emotion_report_section4_key_1_li4:
		"睡眠质量提升（入睡时间缩短，睡眠更连续）",
	emotion_report_section4_key_1_li5: "工作效率提高（能够更好地管理压力）",
	emotion_report_section4_key_2: "2. 需要关注的方面",
	emotion_report_section4_key_2_li1:
		"情绪波动幅度（建议记录情绪日记，找出触发因素）",
	emotion_report_section4_key_2_li2: "压力耐受度（学习更多减压技巧）",
	emotion_report_section4_key_2_li3: "社交互动质量（培养深层次的人际关系）",
	emotion_report_section4_key_2_li4: "自我关爱意识（增加独处质量时间）",
	emotion_report_section4_key_2_li5:
		"生活作息规律（建立更稳定的日常routine）",
	emotion_report_section5_key: "五、后续跟进计划",
	emotion_report_section5_key_1: "1. 短期目标（1-2周）",
	emotion_report_section5_key_1_a: "a) 情绪管理",
	emotion_report_section5_key_1_a_li1: "每天记录3次情绪状态和触发事件",
	emotion_report_section5_key_1_a_li2: "学习并练习1个新的放松技巧",
	emotion_report_section5_key_1_a_li3: "建立早晚5分钟的深呼吸习惯",
	emotion_report_section5_key_1_b: "b) 生活习惯",
	emotion_report_section5_key_1_b_li1: "规律作息，固定睡眠时间",
	emotion_report_section5_key_1_b_li2: "每天进行15分钟户外活动",
	emotion_report_section5_key_1_b_li3: "减少社交媒体使用时间至1小时以内",
	emotion_report_section5_key_1_c: "c) 社交活动",
	emotion_report_section5_key_1_c_li1: "每周与一位朋友进行深入交谈",
	emotion_report_section5_key_1_c_li2: "参加一次集体活动或兴趣小组",
	emotion_report_section5_key_1_c_li3: "练习积极倾听技巧",
	emotion_report_section5_key_2: "2. 中期目标（1-3个月）",
	emotion_report_section5_key_2_a: "a) 心理建设",
	emotion_report_section5_key_2_a_li1: "完成一个8周正念课程",
	emotion_report_section5_key_2_a_li2: "建立稳定的情绪支持系统",
	emotion_report_section5_key_2_a_li3: "掌握3-5个有效的压力管理策略",
	emotion_report_section5_key_2_b: "b) 行为改变",
	emotion_report_section5_key_2_b_li1: "形成规律运动习惯（每周3-4次）",
	emotion_report_section5_key_2_b_li2: "建立健康的饮食模式",
	emotion_report_section5_key_2_b_li3: "发展一项新的兴趣爱好",
	emotion_report_section5_key_2_c: "c) 人际关系",
	emotion_report_section5_key_2_c_li1: "改善家庭沟通模式",
	emotion_report_section5_key_2_c_li2: "扩大社交圈子",
	emotion_report_section5_key_2_c_li3: "学会设立健康的人际边界",
	emotion_report_section6_key: "六、温馨提示",
	emotion_report_section6_key_li1: "情绪起伏是正常的，就像天气变化一样自然",
	emotion_report_section6_key_li2: "保持耐心，改变是循序渐进的过程",
	emotion_report_section6_key_li3: "随时寻求专业帮助是明智和勇敢的选择",
	emotion_report_section7_key: "七、应急联系方式",
	emotion_report_section7_key_li1: "24小时心理援助热线：",
	emotion_report_section7_key_li2: "主治医师联系方式：",
	emotion_report_section7_key_li3: "就近急救中心：",
	emotion_report_section8_key: "八、参考文献",
	emotion_report_section8_key_p1: "世界卫生组织关于心理健康评估的权威指南",
	emotion_report_section8_key_p2:
		"心理障碍诊断与统计手册，情绪评估的黄金标准",
	emotion_report_section8_key_p3:
		"美国国立精神卫生研究所发布的情绪障碍研究最新进展",
	emotion_report_section8_key_p4: "情绪障碍治疗的经典著作",
	emotion_report_section8_key_p5: "辩证行为疗法在情绪调节中的应用指南",
	emotion_report_notes_key: "注意事项：",
	emotion_report_notes_key_li1: "本报告仅供参考，不能替代专业医生的诊断意见",
	emotion_report_notes_key_li2:
		"如果您感觉情绪持续低落或者出现其他不适，请及时就医",
	emotion_report_notes_key_li3:
		'每个人的情绪模式都是独特的，不必过分追求"标准"状态',
	emotion_valence_positive_key: "正向",
	emotion_valence_negative_key: "负向",
	emotion_arousal_high_key: "高活跃",
	emotion_arousal_low_key: "低活跃",
	emotion_va_analyze_key: "Valence-Arousal分析",
	emotion_analyze_result_key: "情绪分析结果：",
	sad_key: "悲伤",
	happy_key: "快乐",
	surprise_key: "惊讶",
	fear_key: "恐惧",
	disgust_key: "厌恶",
	anger_key: "愤怒",
	neutral_key: "中性",
	neglect_key: "忽视",
	speech_sys_title_key: "语音情绪分析",
	speech_sys_desc_key: "语音情绪分析系统介绍",
	speech_sys_desc_welcome_key:
		"欢迎使用我们的语音分析系统。这个强大的工具利用最新的深度学习技术，为您提供精确的情绪识别。",
	speech_sys_desc_li1_key:
		"语音分析基于先进的深度学习模型，能够准确识别多种情绪状态。",
	speech_sys_desc_pre_start_key:
		'准备好开始探索您的情绪世界了吗？点击下方的"开始"按钮，开启您的语音分析之旅！',
	speech_sys_desc_welcome_key1:
		"请点击下方的“开始录音”按钮，即兴录制一段您的说话声音，10~30s即可。",
	speech_sys_desc_welcome_key2: '录制完成后请点击"提交"。',
	recording_key: "录音中...",
	record_action_key: "录音",
	speech_sys_denoise_key: "降噪（除非环境嘈杂，否则不要勾选此框）",
	stop_recording_key: "停止",
	start_recording_key: "开始录音",
	pause_key: "暂停",
	play_key: "播放",
	speech_sys_vioce_analyze_key: "提交",
	speech_sys_noaccess_mic_key: "无法访问麦克风",
	speech_sys_warning_recording_key: "请先录制音频",
	speech_sys_analyze_failed_key: "分析语音失败",
	speech_report_title_key: "心理健康语音情绪状态评估报告",
	speech_report_section1_key: "一、评估概述",
	speech_report_section1_key_desc:
		"本次评估采用了先进的语音情绪识别技术，通过分析您的语音特征，包括音调、语速、音量和语音质地等维度，对您的情绪状态进行了全面量化分析。评估结果显示您目前的整体情绪状态",
	speech_report_section2_key: "二、情绪状态分析",
	speech_report_section2_key_1: "1. 情绪分布概况",
	speech_report_section2_key_1_h1: "积极情绪 (总计",
	speech_report_section2_key_1_h2: "中性情绪",
	speech_report_section2_key_1_h3: "消极情绪 (总计",
	speech_report_section2_key_2: "2. 情绪特征分析",
	speech_report_section2_key_2_h1: "情绪活跃度",
	speech_report_section2_key_2_h2: "情绪效价",
	speech_report_section3_key: "三、个性化建议",
	speech_report_section3_key_1: "1. 积极加强",
	speech_report_section3_key_1_a: "a) 保持积极情绪",
	speech_report_section3_key_1_a_li1: "积极的生活方式和活动模式",
	speech_report_section3_key_1_a_li2: "记录带来幸福感的日常活动",
	speech_report_section3_key_1_a_li3: "建立积极情绪日记",
	speech_report_section3_key_1_a_li4: "培养感恩意识，每日记录3件感恩事项",
	speech_report_section3_key_1_b: "b) 情绪稳定性维护",
	speech_report_section3_key_1_b_li1: "保持规律的生活作息",
	speech_report_section3_key_1_b_li2: "固定运动和放松时间",
	speech_report_section3_key_1_b_li3: "维持健康的社交活动",
	speech_report_section3_key_1_b_li4: "培养正念习惯，每日进行10-15分钟冥想",
	speech_report_section3_key_2: "2. 改善建议",
	speech_report_section3_key_2_a: "a) 情绪表达丰富度",
	speech_report_section3_key_2_a_li1: "在安全的社交环境中练习表达不同情绪",
	speech_report_section3_key_2_a_li2: "扩展情绪词汇库",
	speech_report_section3_key_2_a_li3: "提高情绪识别的精确度",
	speech_report_section3_key_2_a_li4: "参与情绪表达工作坊或课程",
	speech_report_section3_key_2_b: "b) 压力管理技能",
	speech_report_section3_key_2_b_li1: "学习科学的压力管理方法",
	speech_report_section3_key_2_b_li2: "建立健康的压力释放渠道",
	speech_report_section3_key_2_b_li3: "培养积极的兴趣爱好",
	speech_report_section3_key_2_b_li4: "建立支持性社交网络",
	speech_report_section4_key: "四、后续跟进计划",
	speech_report_section4_key_1: "1. 短期目标（1-2周）",
	speech_report_section4_key_1_a: "a) 情绪觉察",
	speech_report_section4_key_1_a_li1: "每日记录3个幸福时刻",
	speech_report_section4_key_1_a_li2: "使用情绪跟踪APP记录情绪变化",
	speech_report_section4_key_1_a_li3: "练习识别细微的情绪变化",
	speech_report_section4_key_1_a_li4: "建立情绪日记习惯",
	speech_report_section4_key_1_b: "b) 生活习惯",
	speech_report_section4_key_1_b_li1: "保持规律作息",
	speech_report_section4_key_1_b_li2: "每天进行15-30分钟有氧运动",
	speech_report_section4_key_1_b_li3: "保证7-8小时充足睡眠",
	speech_report_section4_key_1_b_li4: "培养一项新的兴趣爱好",
	speech_report_section4_key_2: "2. 中期目标（1-3个月）",
	speech_report_section4_key_2_a: "a) 能力提升",
	speech_report_section4_key_2_a_li1: "参加情绪管理工作坊",
	speech_report_section4_key_2_a_li2: "学习2-3种放松技巧",
	speech_report_section4_key_2_a_li3: "掌握基础冥想方法",
	speech_report_section4_key_2_a_li4: "提升沟通和表达能力",
	speech_report_section4_key_2_b: "b) 社交发展",
	speech_report_section4_key_2_b_li1: "每周参加1-2次群体活动",
	speech_report_section4_key_2_b_li2: "深化现有友谊关系",
	speech_report_section4_key_2_b_li3: "扩展社交圈",
	speech_report_section4_key_2_b_li4: "提升人际互动质量",
	speech_report_section5_key: "五、注意事项",
	speech_report_section5_key_li1: "保持当前的积极情绪状态，但避免过度亢奋",
	speech_report_section5_key_li2: "接纳情绪的自然波动，不追求情绪永远积极",
	speech_report_section5_key_li3: "定期进行情绪状态评估，建议每月一次",
	speech_report_section5_key_li4: "如果情绪出现明显波动，及时寻求专业支持",
	speech_report_section6_key: "六、参考文献",
	speech_report_section6_key_p1: "语音情绪识别的权威研究",
	speech_report_section6_key_p2: "语音情绪分析的发展综述",
	speech_report_section6_key_p3: "语音情感计算的最新进展",
	speech_report_section7_key: "七、应急联系方式",
	speech_report_section7_key_li1: "24小时心理援助热线：",
	speech_report_section7_key_li2: "主治医师联系方式：",
	speech_report_section7_key_li3: "就近急救中心：",
	surprised_happy_key: "惊喜",
	hrv_report_score: "得分",
	suggestion: "建议",
	exceed_percentage_key: "超过{num}%同龄人群",
	better_than_percentage_key: "状态优于{num}%同龄人群",
	// HRV Store 相关翻译
	hrv_store_data_incomplete: "数据不完整，无法提交",
	hrv_store_http_error: "HTTP错误: {status}",
	hrv_store_user_expired: "用户已过期",
	hrv_store_submit_failed: "提交失败",
	hrv_store_request_timeout: "请求超时",
	hrv_store_network_error: "网络错误: {status}",
	hrv_store_unknown_error: "未知错误",
	hrv_report_data_empty: "暂无报告数据",
	retry_key: "重试",
	hrv_report_v2: {
		current: "当前",
		low: "低",
		medium: "中",
		medium_bottom: "中下",
		medium_top: "中上",
		medium_low: "中低",
		medium_high: "中高",
		high: "高",
		strong: '强',
		weak: '弱',
		lower: "较低",
		good: "良好",
		higher: "较高",
		normal: '正常',
		comprehensive_advice: "综合评估",
		next_check_date: "建议下一次检查日期",
		doctor: "医生",
		date: "日期",
		index_interpretation: "指标解读",
		trend_analysis: "趋势分析",
		health_advice: "健康生活方案",
		trend_chart_point_text: "请按时复查",
		assessment: '评估',
		current_assessment: '当前评估',
		name: "姓名",
		gender: "性别",
		male: "男",
		female: "女",
		age: "年龄",
		id_number: "编号",
		time: "时间",
		hotline: "咨询热线",
		page: "第",
		page_suffix: "页",
		// HeadsetPage 相关翻译
		gaba_rx_title: "GABA Rx 智能穿戴神器",
		usage_suggestion_title: "使用建议",
		tavns_title: "taVNS 经皮耳迷走神经刺激",
		gaba_rx_description_part1: "采用",
		gaba_rx_description_tech: "经皮耳迷走神经刺激技术（taVNS）",
		gaba_rx_description_part2: "——通过在耳部迷走神经分支区域施加温和电脉冲，结合音律和呼吸引导，",
		gaba_rx_description_highlight: "辅助调节自主神经功能，改善睡眠质量、缓解日常焦虑与压力。",
		recommended_scenarios: "推荐使用场景",
		scenario_1: '白天忙到爆，晚上脑子 “开夜会”，躺平也失眠。',
		scenario_2: '工作学习后，脑子卡壳晕乎乎，神经还在 “飙速”。',
		scenario_3: "没事也焦虑，总胡思乱想，心里紧巴巴。",
		scenario_4: "午后犯困，想小睡却静不下心。",
		scenario_5: "困得很，躺下却难深睡，干着急。",
		scenario_6: "压力堆成山，夜夜难入眠，晨起没精神。",
		scientific_background: "科学背景",
		scientific_background_desc: "taVNS（transcutaneous auricular vagus nerve stimulation，经皮耳迷走神经刺激）是一种非侵入式神经调控技术。通过耳机在外耳道或耳甲腔区域精准刺激耳迷走神经分支，激活大脑的迷走神经网络，从而帮助恢复自主神经系统的平衡。",
		core_mechanism: "核心机制",
		stimulation_parameters: "刺激参数：采用 20Hz 低频脉冲，作用于耳迷走神经末梢。",
		regulation_effect: '调节作用：通过激活副交感神经、抑制过度兴奋的交感神经，实现“身心稳态”的恢复。',
		physiological_effects: "生理效应",
		physiological_effects_desc: '研究表明，taVNS 能在短时间内激活副交感神经，促进身体放松，缓解紧张和压力，并有助于情绪调节与认知功能提升。仅需几分钟刺激，即可让身体进入自然的“放松与修复”。'
	},
}
